import React from 'react';
import clone from 'lodash/clone';
import { Button, Col, Form, Input, InputNumber, notification, PageHeader, Row } from 'antd';
import { useBack, useHandleSubmit, useFirestore, useAuth } from '@betwyll/btw-core-backoffice';
import { useAsync } from 'react-async';
import { useTranslation } from 'react-i18next';

const formLayout = {
  layout: 'horizontal',
  labelCol: { span: 3 },
  wrapperCol: { span: 10 },
};

function CreateForm({ form, onSubmit, loading }) {
  const { getFieldDecorator } = form;

  const { t } = useTranslation('materials');

  const handleSubmit = useHandleSubmit({ form, handler: onSubmit });

  return (
    <Form onSubmit={handleSubmit} {...formLayout}>
      <Form.Item label={t('name')} extra={t('title_hint')}>
        {getFieldDecorator('name', {
          rules: [
            {
              required: true,
            },
          ],
        })(<Input />)}
      </Form.Item>
      <Form.Item label={t('index')} extra={t('title_hint')}>
        {getFieldDecorator('index', {
          rules: [
            {
              required: true,
            },
          ],
        })(<InputNumber />)}
      </Form.Item>
      <Row type="flex" justify="end">
        <Col span={4}>
          <Button type="primary" htmlType="submit" loading={loading}>
            {t('create')}
          </Button>
        </Col>
      </Row>
    </Form>
  );
}

const PromoCodeCreateForm = Form.create()(CreateForm);

async function createPromoCode([data, clean], { ref, firestore, onSuccess }) {
  try {
    const d = clone(data);
    d.materialRefs = d.materialRefs.map(id =>
      firestore()
        .collection('materials')
        .doc(id),
    );
    await ref.set(d);
    clean();
    onSuccess();
  } catch (e) {
    notification.error({ message: e.message });
  }
}

export default function PromoCodeCreate() {
  const onBack = useBack();
  const firestore = useFirestore();
  const auth = useAuth();

  const ref = firestore()
    .collection('materialCategories')
    .doc();

  const { run, isPending: creating } = useAsync({
    deferFn: createPromoCode,
    firestore,
    ref,
    auth,
    onSuccess: onBack,
  });

  const { t } = useTranslation('materials');

  return (
    <>
      <PageHeader title={t('new_promoCode')} onBack={onBack} />
      <PromoCodeCreateForm onSubmit={run} loading={creating} id={ref.id} />
    </>
  );
}
